import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';

const useCaravanaStyles = createUseStyles((theme: Theme) => {
    return {
        container: {
            backgroundColor: theme.colors.espresso_brown,
            fontFamily: theme.fonts.apex,
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(4),
            color: theme.palette.primary.light,
            position: 'relative',
            marginBottom: 0,
            [theme.breakpoints.down('sm')]: {
                marginBottom: theme.spacing(-4),
                padding: theme.spacing(2),
            },
        },
        titleSection: {
            textAlign: 'center',
            marginBottom: theme.spacing(6),
            maxWidth: '900px',
            [theme.breakpoints.down('sm')]: {
                marginTop: theme.spacing(0),
                marginBottom: theme.spacing(4),
            },
        },
        mainTitle: {
            fontFamily: theme.fonts.poplar,
            fontSize: '4.5rem',
            color: theme.palette.primary.light,
            margin: 0,
            lineHeight: 1.1,
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
            letterSpacing: '2px',
            [theme.breakpoints.down('md')]: {
                fontSize: '3rem',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '2.2rem',
            },
        },
        subtitleText: {
            fontSize: '1.4rem',
            lineHeight: 1.5,
            color: theme.palette.primary.light,
            fontWeight: '400',
            margin: `${theme.spacing(3)} 0`,
            opacity: 0.9,
            [theme.breakpoints.down('md')]: {
                fontSize: '1.2rem',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '1rem',
                margin: `${theme.spacing(2)} 0`,
            },
        },
        magicianSection: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: theme.spacing(6),
            position: 'relative',
            [theme.breakpoints.down('sm')]: {
                marginBottom: theme.spacing(4),
            },
        },
        magicianImage: {
            width: '400px',
            height: 'auto',
            transition: 'transform 0.3s ease',
            '&:hover': {
                transform: 'scale(1.02)',
            },
            [theme.breakpoints.down('md')]: {
                width: '350px',
            },
            [theme.breakpoints.down('sm')]: {
                width: '280px',
            },
        },
        eventsSection: {
            position: 'relative',
            width: '100%',
            maxWidth: '1200px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        calendarIconContainer: {
            width: '80px',
            height: '80px',
            backgroundColor: theme.colors.desert_sand_gold,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: theme.spacing(4),
            zIndex: 2,
            boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
            [theme.breakpoints.down('sm')]: {
                width: '60px',
                height: '60px',
                marginBottom: theme.spacing(3),
            },
        },
        calendarIcon: {
            fontSize: '2.5rem',
            color: theme.colors.espresso_brown,
            [theme.breakpoints.down('sm')]: {
                fontSize: '2rem',
            },
        },
        eventsGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: theme.spacing(3),
            width: '100%',
            [theme.breakpoints.down('md')]: {
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: theme.spacing(2),
            },
            [theme.breakpoints.down('sm')]: {
                gridTemplateColumns: '1fr',
                gap: theme.spacing(2),
            },
        },
        eventCard: {
            border: `3px dotted ${theme.colors.desert_sand_gold}`,
            borderRadius: '15px',
            padding: theme.spacing(3),
            backgroundColor: 'rgba(209, 168, 94, 0.1)',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 16px rgba(209, 168, 94, 0.3)',
            },
            [theme.breakpoints.down('sm')]: {
                padding: theme.spacing(2),
                gap: theme.spacing(1.5),
            },
        },
         eventMagazin: {
            fontSize: '1.2rem',
            fontWeight: 'bold',
            color: theme.colors.desert_sand_gold,
            textAlign: 'center',
            whiteSpace: 'pre-line',
            marginBottom: theme.spacing(1),
            [theme.breakpoints.down('sm')]: {
                fontSize: '1rem',
                marginBottom: theme.spacing(0.5),
            },
        },
        eventDetails: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: theme.spacing(1),
            borderBottom: `1px solid rgba(209, 168, 94, 0.3)`,
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                gap: theme.spacing(0.5),
                textAlign: 'center',
            },
        },
        eventZi: {
            fontSize: '1.1rem',
            fontWeight: 'bold',
            color: theme.palette.primary.light,
            [theme.breakpoints.down('sm')]: {
                fontSize: '1rem',
            },
        },
        eventData: {
            fontSize: '1.1rem',
            color: theme.palette.primary.light,
            fontWeight: '500',
            [theme.breakpoints.down('sm')]: {
                fontSize: '1rem',
            },
        },
        eventTimeInfo: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                gap: theme.spacing(0.5),
                textAlign: 'center',
            },
        },
        eventInterval: {
            fontSize: '1rem',
            color: theme.palette.primary.light,
            opacity: 0.8,
            [theme.breakpoints.down('sm')]: {
                fontSize: '0.9rem',
            },
        },
        eventDurata: {
            fontSize: '1rem',
            color: theme.colors.desert_sand_gold,
            fontWeight: 'bold',
            [theme.breakpoints.down('sm')]: {
                fontSize: '0.9rem',
            },
        },
    };
});

export default useCaravanaStyles;